module.exports = __webpack_public_path__ + "img/logo23.4ae60a24.png";